import { useNavigate } from "react-router-dom";

const images = [
  "image024.jpg",
  "image025.jpg",
  "image026.jpg",
  "image027.jpg",
  "image028.jpg",
  "image029.jpg",
  "image030.jpg",
  "image031.jpg",
];

export default function LetoniaPage() {
  const navigate = useNavigate();

  function PhotoGrid({ images, folder }) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {images.map((img, idx) => (
          <div
            key={img}
            className="aspect-square overflow-hidden rounded-lg shadow-lg bg-white flex items-center justify-center hover:scale-105 transition-transform duration-200"
          >
            <img
              src={
                `/proiecte/Erasmus+/pozeLetonia/${img}`
              }
              alt={`Letonia Erasmus ${idx + 1}`}
              className="object-cover w-full h-full"
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-4 text-center">
          Întâlnire de lucru în Razekne State Gymnasium No1, Rezekne, Letonia în
          cadrul proiectului Erasmus+ KA229 “OUR PAST OUR FUTURE “
        </h1>
        <p className="mb-4">
          În săptămâna 11-15 octombrie 2021, Liceul Tehnologic "Dr. Florian
          Ulmeanu" Ulmeni a participat on-line la activitățile din cadrul
          proiectului Erasmus+, desfășurate în Letonia. Implicarea elevilor și a
          profesorilor liceului nostru a fost apreciată, activitatea
          bucurându-se de mult succes.
        </p>
        <PhotoGrid
          images={images}
          folder="proiecte/erasmus+/pozeLetonia"
          altPrefix="Letonia Erasmus"
        />
        <button
          onClick={() => navigate("/proiecte/erasmus+")}
          className="m-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 float-right"
        >
          &larr; Înapoi
        </button>
      </main>
    </div>
  );
}
